import { render, staticRenderFns } from "./PackForm.vue?vue&type=template&id=17b2164a&scoped=true"
import script from "./PackForm.vue?vue&type=script&lang=js"
export * from "./PackForm.vue?vue&type=script&lang=js"
import style0 from "./PackForm.vue?vue&type=style&index=0&id=17b2164a&prod&scoped=true&lang=scss"
import style1 from "./PackForm.vue?vue&type=style&index=1&id=17b2164a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2164a",
  null
  
)

export default component.exports